export enum colors {
    warning = 'warning',
    error = 'error',
    primaryAuth = 'primaryAuth',
    demo = 'demo',
    cookies = 'cookies',
}
